module.exports = {
      id: "newslettericon-usage",
      viewBox: "0 0 48 47.861",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#newslettericon",
      toString: function () {
        return this.url;
      }
    }